import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ToastProvider } from './components/ui/ToastProvider';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import BusinessHome from './pages/business/BusinessHome';
import BusinessAboutUs from './pages/business/BusinessAbout';
import BusinessGallery from './pages/business/BusinessGallery';
import BusinessProductsCatalog from './pages/business/BusinessProductsCatalog';
const App: React.FC = () => {
  return (
    <Router>
      <ToastProvider>
        <CartProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/quienes-somos" element={<About />} />
            <Route path="/galeria" element={<Gallery />} />
            <Route path="/contacto" element={<Contact />} />

            <Route path="/:businessId" element={<BusinessHome />} />
            <Route path="/:businessId/quienes-somos" element={<BusinessAboutUs />} />
            <Route path="/:businessId/productos" element={<BusinessProductsCatalog />} />
            <Route path="/:businessId/galeria" element={<BusinessGallery />} />
            <Route path="/:businessId/contacto" element={<Contact />} />
          </Routes>
        </CartProvider>
        {/* react-hot-toast container moved to root `src/index.tsx` */}
      </ToastProvider>
    </Router>
  );
};

export default App;
